import { INSURANCE_TYPES } from '@zocdoc-frontend-common/utils-react';
import InsuranceForm from './components/InsuranceForm';
import {
    CARRIER,
    IM_PAYING_MYSELF_CAPITALIZED_TEXT,
    ROOT_STATE_KEY,
} from './constants';
import InsurancePropTypes from './InsurancePropTypes';
import insuranceReducer from './insuranceReducer';

const { IM_PAYING_MYSELF } = CARRIER;

export {
    IM_PAYING_MYSELF,
    IM_PAYING_MYSELF_CAPITALIZED_TEXT,
    INSURANCE_TYPES,
    ROOT_STATE_KEY as INSURANCE_STATE_KEY,
    InsuranceForm,
    InsurancePropTypes,
    insuranceReducer,
};
